<template>
  <b-modal
    v-model="show"
    title="Cambiar estado de escaneo"
    ok-title="Confirmar"
    cancel-title="Cancelar"
    ok-variant="secondary"
    @ok.prevent="onConfirm"
  >
    <div class="confirm-body">
      <p v-if="delivery">
        Vas a marcar este envío ({{ delivery.id }}) como
        <strong class="text-success">Recepcionado</strong>.
      </p>
      <p v-else>No hay envío seleccionado.</p>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ConfirmChangeScanStatusModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    delivery: {
      type: Object,
      default: null
    }
  },
  computed: {
    show: {
      get() { return this.value },
      set(v) { this.$emit('input', v) }
    }
  },
  methods: {
    onConfirm() {
      this.$emit('confirmed', this.delivery)
    },
    formatDate(date) {
      if (!date) return ''
      try {
        return new Date(date).toLocaleString('es-CL')
      } catch (e) {
        return String(date)
      }
    }
  }
}
</script>

<style scoped>
.confirm-body {
  font-size: 0.95rem;
  margin-bottom: 0.75rem;
}

.confirm-meta {
  font-size: 0.85rem;
  color: #6c757d;
  border-top: 1px solid #e9ecef;
  padding-top: 0.75rem;
}

.confirm-meta p {
  margin: 0.25rem 0;
}

.text-success {
  color: #28a745;
  font-weight: 600;
}

.text-danger {
  color: #dc3545;
  font-weight: 600;
}
</style>